import type { Breadcrumb } from '~/graphql/types/graphql'

export class Product {
    static product: any

    static set(product: any) {
        this.product = product
        return this
    }

    static badges() {
        this.product = {
            ...this.product,
            productBadges: this.product.productFlags,
        }
        return this
    }

    static image() {
        const imageSrc: string = this.product.smallImage?.src || ''
        const imageAlt: string = this.product.smallImage?.alt || this.product.name

        this.product = {
            ...this.product,
            imageSrc,
            imageAlt,
        }
        return this
    }

    static algoliaImage() {
        const imageSrc: string = this.product.smallImage?.url || ''
        const imageAlt: string = this.product.smallImage?.label || this.product.name || ''

        this.product = {
            ...this.product,
            imageSrc,
            imageAlt,
        }
        return this
    }

    static mirakl() {
        const { miraklOffers, priceRange } = this.product

        if (!miraklOffers?.length && !priceRange) return this

        // todo w natywce dodac productPrice
        const productPrice = miraklOffers?.length ? miraklOffers?.[0].formattedPrice.price : priceRange.minimumPrice

        // todo powinno byc ograne w template
        const shopName = miraklOffers?.[0]?.shopName || ''
        const shopId = miraklOffers?.[0]?.shopId || ''
        const offerId = miraklOffers?.[0]?.offerId

        this.product = {
            ...this.product,
            productPrice,
            shopName,
            shopId,
            offerId,
        }

        return this
    }

    static algoliaMirakl() {
        const {
            miraklOffers,
            price: { finalPrice, regularPrice },
        } = this.product

        const shopName = miraklOffers?.[0]?.shopName || ''
        const shopId = miraklOffers?.[0]?.shopId || ''
        const offerId = miraklOffers?.[0]?.offerId

        this.product = {
            ...this.product,
            productPrice: { finalPrice, regularPrice },
            shopName,
            shopId,
            offerId,
        }

        return this
    }

    static url() {
        const { PRODUCT_PAGE_PREFIX } = useAppConfig()
        const url = `/${PRODUCT_PAGE_PREFIX}/${this.product.url}`
        this.product = {
            ...this.product,
            url,
        }

        return this
    }

    static algoliaUrl() {
        const { PRODUCT_PAGE_PREFIX } = useAppConfig()
        const url = `/${PRODUCT_PAGE_PREFIX}/${this.product.urlKey}`
        this.product = {
            ...this.product,
            url,
        }

        return this
    }

    static breadcrumbs() {
        let bread: Breadcrumb[] = []
        if (this.product.categories) {
            bread =
                this.product.categories.length > 0
                    ? [
                          ...this.product.categories[0]?.breadcrumbs,
                          {
                              name: this.product.categories[0]?.name,
                              path: this.product.categories[0]?.path,
                          },
                      ]
                    : []
        }

        this.product = {
            ...this.product,
            breadcrumbs: bread,
        }

        return this
    }

    static dataLayer() {
        this.product = {
            ...this.product,
            categoryId: this.product?.dlCategoryIdentifier || this.product?.dataLayer?.categoryIdentifier || '',
            categoryHierarchyId:
                this.product?.dlCategoryIdentifierPath || this.product?.dataLayer?.categoryIdentifierPath || '',
            categoryName: this.product?.dlCategoryName || this.product?.dataLayer?.categoryName || '',
            parentCategoryId:
                this.product?.dlParentCategoryIdentifier || this.product?.dataLayer?.parentCategoryIdentifier || '',
            parentCategoryName: this.product?.dlParentCategoryName || this.product?.dataLayer?.parentCategoryName || '',
        }

        return this
    }

    static brand() {
        const brand = this.product.brandLabel || ''

        this.product = {
            ...this.product,
            brand,
        }
        return this
    }

    static get result() {
        return this.product
    }
}
